define('PDPBanner.View',
	[
		'PDPBanner.tpl',
		'PDPBanner.SS2Model',
		'Backbone'
	],
	function (
		pdpbanner_tpl,
		PDPBannerSS2Model,
		Backbone
	) {
		'use strict';

		//Anchor Group - An Phan
		//Retrieves item info from Product Details Page to work with service file. 

		return Backbone.View.extend({

			template: pdpbanner_tpl,

			initialize: function (options) {

				var PDP = options.container.getComponent('PDP');
				var iteminfo = PDP.getItemInfo();
				var self = this;

				this.header = iteminfo.item.custitem_ag_pdp_banner_header;
				this.subtext = iteminfo.item.custitem_ag_pdp_banner_subtext;
				this.fullURL = null;

				this.model = new PDPBannerSS2Model();
				this.model.fetch({
					data: {
						itemId: iteminfo.item.internalid
					}
				})
					.done(function (resp){
						self.fullURL = resp && resp.fileUrl;
						self.render();
					});
			},

			getContext: function getContext() {
				return {
					header: this.header,
					subtext: this.subtext,
					fullURL: this.fullURL
				}
			}
		});
	});
